import React from "react";
import Header from "./Header";

class App extends React.Component {
	render() {
		return (
			<div className="dezk">
				<div>
					<Header />
				</div>
			</div>
		);
	}
}

export default App;